import React, { useEffect, useState } from "react";
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Button, Box, Text,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { CustomToast, Dropdown, FormInput } from "../../../../../components";
import { useFetch } from "../../../../../hooks/useFetch";
import { Iuser, Team, IServiceOption } from "../../ServiceTeamManagement/modal";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
interface Props { isOpen: boolean; onClose: () => void; onSave: () => void; selectedTeam: Team | null; }
interface FormData {
  teamName: string;
  teamLeadId: number;
  serviceInterestedId: number;
}

const schema = yup.object({
  teamName: yup.string().required("Team Name is required").trim(),
  teamLeadId: yup.number().typeError("Team Lead is required").moreThan(0, "Team Lead is required").required("Team Lead is required"),
  serviceInterestedId: yup.number().typeError("Service Interested In is required").moreThan(0, "Service Interested In is required").required("Service Interested In is required"),
});



const AddNewTeam: React.FC<Props> = ({ isOpen, onClose, onSave, selectedTeam, }) => {
  const [user, setUser] = useState<Iuser[]>([]);
  const [services, setServices] = useState<IServiceOption[]>([]);
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [memberModal, setMemberModal] = useState(false);
  const [memberInfo, setMemberInfo] = useState<any>(null);

  const { control, handleSubmit, reset, formState: { errors }, }
    = useForm<FormData>({
      resolver: yupResolver(schema),
      defaultValues: { teamName: "", teamLeadId: 0, serviceInterestedId: 0 },
    });


  useEffect(() => {
    if (selectedTeam) {
      reset({
        teamName: selectedTeam.teamName,
        teamLeadId: selectedTeam.teamLeadId,
        serviceInterestedId: selectedTeam.serviceInterestedId || (selectedTeam as any).serviceInterestedInId || (selectedTeam as any).serviceId || 0,
      });
    } else {
      reset({ teamName: "", teamLeadId: 0, serviceInterestedId: 0 });
    }
  }, [selectedTeam, reset, isOpen]);



  const forceCreateTeam = async () => {
    const response = await fetchApi("ServiceTeamMast", "POST", { ...memberInfo.body, forceCreate: true }, null, "Team Added Successfully"
    );
    if (!response)
      return;
    setMemberModal(false);
    onSave();
    onClose();
  };



  const onSubmit = async (data: FormData) => {
    const body = {
      teamName: data.teamName.trim(),
      teamLeadId: Number(data.teamLeadId),
      serviceInterestedId: Number(data.serviceInterestedId),
      forceCreate: false
    };
    let response;
    if (selectedTeam) {
      response = await fetchApi(`ServiceTeamMast/${selectedTeam.teamId}`, "PUT", body, null, "Team Updated  Successfully");
    } else {
      response =
        await fetchApi("ServiceTeamMast", "POST", body, null, "Team Added Successfully");
    }
    if (!response)
      return;
    if (response.code === "ALREADY_MEMBER") {
      setMemberInfo({ ...response, body });
      setMemberModal(true);
      return;
    }
    onSave();
    onClose();
  };

  const getUser = async () => {
    const res = await fetchApi("Dropdown/userss", "GET", null, null, "");
    if (res) setUser(res);
  };

  const getServices = async () => {
    const res = await fetchApi("Dropdown/services", "GET", null, null, "");
    if (res && Array.isArray(res)) {
      const mappedServices = res.map((s: any) => ({
        serviceId: s.serviceId ?? s.ServiceId ?? s.id,
        serviceName: s.serviceName ?? s.ServiceName ?? s.name ?? "",
      }));
      setServices(mappedServices);
    }
  };

  useEffect(() => {
    getUser();
    getServices();
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="16px">
          <ModalHeader>{selectedTeam ? "Edit Team" : "Add Team"}</ModalHeader>
          <ModalCloseButton />
          <form onSubmit={handleSubmit(onSubmit)}>
            <ModalBody>
              <Box mb={4}>
                <FormInput isRequired control={control} name="teamName"
                  type="string" label="Team Name" placeholder="Enter Team Name" errors={errors}
                />
              </Box>

              <Box mb={4}>
                <Dropdown
                  isRequired control={control} name="teamLeadId" label="Team Lead" options={user}
                  valueKey="teamLeadId" labelKey="teamLead" errors={errors}
                  disable={selectedTeam ? true : false}
                />
              </Box>

              <Box>
                <Dropdown
                  isRequired control={control} name="serviceInterestedId" label="Service Interested In" options={services}
                  valueKey="serviceId" labelKey="serviceName" placeholder="Select Service Interested In" errors={errors}
                />
              </Box>
            </ModalBody>
            <ModalFooter>
              <Button mr={3} onClick={onClose}> Cancel </Button>
              <Button type="submit" isDisabled={loading} bg="#4F46E5" color="white" _hover={{ bg: "#4338CA" }}
              >
                {selectedTeam ? "Update" : "Save"}
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>




      <Modal isOpen={memberModal} onClose={() => setMemberModal(false)} isCentered >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader> Team Member Already Exists </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text> This user is already a member of <strong> {memberInfo?.currentTeamName}</strong>. </Text>
            <Text mt={4}> If you continue, they will be removed from that team and added as Team Lead of the new team.</Text>
          </ModalBody>
          <ModalFooter>
            <Button mr={3} onClick={() => setMemberModal(false)} > Cancel </Button>
            <Button colorScheme="blue" onClick={forceCreateTeam} > Continue </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AddNewTeam;